import { createContext } from 'react';

export interface IFeatureFlagContext {
  forceSSOEnabled: boolean;
  multiUserPools: boolean;
}

export const FeatureFlagContext = createContext<IFeatureFlagContext>({
    forceSSOEnabled: false,
    multiUserPools: false
});
